import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ExpoTheme } from "./themes/ExpoTheme";
import ExpoPlannerBuilder from "./ExpoPlannerBuilder";
import "react-quill/dist/quill.snow.css";
import RegFormContainer from "./formbuilder/container/RegFormContainer";
import ResgistrationConfirmation from "./pages/ResgistrationConfirmation";
import TermsConditions from "./formbuilder/templates/TermsConditions";
import GtagLoader from "./gtag/GtagLoader";
import GtagRouterTracker from "./gtag/GtagRouterTracker";
import OpenStudentRegistration from "./pages/StudentRegistration";
import ModernSelectionComponent from "./pages/RegistrationsSelect";
import FloorPlanPathDemo from "./pages/FlowPath";
import SocialShare from "./pages/SocialWall";
import MetaPixelLoader from "./gtag/MetaPixelLoader";
import MetaPixelRouterTracker from "./gtag/MetaPixelRouterTracker";
import { APP_ID, TD_ID } from "./utils/constants";
import ServiceBadge from "./components/ServiceBadge";
import OnsiteReuseContainer from "./components/OnsiteReuseContainer";
import ServicePerson from "./components/ServicePerson";
import ServiceWelcomeMessage from "./components/ServiceWelcomeMessage";
import ServiceBadgePreview from "./components/ServiceBadgePreview";
const queryClient = new QueryClient();
const App = () => {
  return (
    <>
      <GtagLoader />
      <MetaPixelLoader />
      <ThemeProvider theme={ExpoTheme}>
        <QueryClientProvider client={queryClient}>
          <Fragment>
            <BrowserRouter>
              <GtagRouterTracker />
              <MetaPixelRouterTracker />
              <ToastContainer autoClose={1500} />
              <Routes>
                <Route path="/" element={<ExpoPlannerBuilder />} />
                <Route
                  path="/service-badge"
                  element={
                    <OnsiteReuseContainer>
                      <ServiceBadge />
                    </OnsiteReuseContainer>
                  }
                />
                <Route
                  path="/service-badge/:id"
                  element={
                    <OnsiteReuseContainer>
                      <ServicePerson />
                    </OnsiteReuseContainer>
                  }
                />
                <Route
                  path="/service-badge-welcome/:id"
                  element={
                    <OnsiteReuseContainer>
                      <ServiceWelcomeMessage />
                    </OnsiteReuseContainer>
                  }
                />

                <Route
                  path="/service-badge-preview/:id"
                  element={
                    <OnsiteReuseContainer>
                      <ServiceBadgePreview />
                    </OnsiteReuseContainer>
                  }
                />

                <Route
                  path="/student-registration"
                  element={<OpenStudentRegistration />}
                />
                <Route
                  path="/visitor-registration"
                  element={<RegFormContainer APP_ID={APP_ID} />}
                />
                <Route
                  path="/visitor-registration/:type"
                  element={<RegFormContainer APP_ID={APP_ID} />}
                />
                <Route
                  path="/tradedelegation-registration"
                  element={<RegFormContainer APP_ID={TD_ID} />}
                />

                <Route
                  path="/registrations"
                  element={<ModernSelectionComponent />}
                />
                <Route path="/social-share" element={<SocialShare />} />
                <Route path="/konva-path" element={<FloorPlanPathDemo />} />
                <Route
                  path="/registration-confirmation"
                  element={<ResgistrationConfirmation />}
                />
                <Route path="/terms-conditions" element={<TermsConditions />} />
              </Routes>
            </BrowserRouter>
          </Fragment>
        </QueryClientProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
